// extracted by mini-css-extract-plugin
module.exports = {"noCertContainer":"style_noCertContainer__wxePf","certImg":"style_certImg__1_sON","tipsOne":"style_tipsOne__2tdN5","tipsTwo":"style_tipsTwo__1xh_b"};